<tr *transloco="let t">
  <td class="name" [ngClass]="{ active: userData.isUser }">{{ userData.name }}</td>
  <td>{{ userData.email }}</td>
  <td>{{ displayRole }}</td>
  <td class="date" [ngClass]="{ active: !userData.isUser }">
    {{ userData.invited | date : 'd. M. y' }}
  </td>
  <td class="date">
    {{ userData.lastLogin ? (userData.lastLogin | date : 'd. M. y HH:mm') : '' }}
  </td>
  <td class="text-end">
    <div class="actions" *ngIf="!userData.isUser && userData.invitationId">
      <button type="button" class="refresh" (click)="onResend()" [title]="t('users/resendInvitation')">
        <i class="material-symbols-rounded">refresh</i>
      </button>
      <button type="button" class="delete" (click)="onDelete()" [title]="t('users/deleteInvitation')">
        <i class="material-symbols-rounded">delete</i>
      </button>
    </div>

    <app-context-menu
      *ngIf="userData.isUser"
      [menuType]="menuTypeEnum.USER"
      [data]="userData"
      (refreshData)="refreshData.emit()"
    ></app-context-menu>
  </td>
</tr>
